<template lang="pug">
el-dialog(title='順序変更', :visible.sync='visible', width='50%', :before-close='hideModal')
  div.c-dialog-header-fun
    template(v-if='type === "list"')
      el-button(@click='hideModal') キャンセル
      el-button(v-if='type === "list"' @click='onSave' type='primary') 変更を保存
    template(v-else)
      el-button(@click='hideModal') 閉じる
  draggable.c-list__radio(v-model='myList' element='ul')
    li(v-for='(data, index) in list2' :key='index')
      template(v-if='type === "image"')
        .c-thumb__list
          .c-thumb__wrp
            .c-thumb__item(:style='{ backgroundImage: "url(" + data.uri + ")"}')
      template(v-if='type === "movie"')
        .c-thumb__list
          .c-thumb__wrp
            video.c-thumb__item(muted autoplay loop)
              source(:src='data.uri' type='video/mp4')
      template(v-else-if='type === "list"')
        .el-radio.is-bordered {{getDisplayText(data)}}
      template(v-else)
        .el-radio.is-bordered {{getTitle(data.item_type)}}

</template>

<script>
import draggable from 'vuedraggable'
export default { name: 'ElementModalSortElement',
  data () {
    return {
      modaltype: 'sortelement',
      list2: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'element'
    },
    displaykey: {
      type: String,
      default: 'title'
    }
  },
  methods: {
    init () {
      this.list2 = this.list
    },
    onSave () {
      const sortList = this.list2.map(v => v.id)
      this.$emit('saveSort', sortList)
    },
    hideModal () {
      this.$emit('hideModal', this.modaltype)
    },
    getDisplayText (data) {
      let text = null
      if (this.displaykey === 'title') {
        text = `${data.date ? data.date : '未設定'} - ${data.title.ja}`
      } else if (this.displaykey === 'name') {
        text = data.name.ja
      }
      return text
    },
    /**
     * @param {String} type
     * @returns {String}
     */
    getTitle (type) {
      let str = null
      if (type === 'videoOrStill') {
        str = 'メイン画像 or 動画'
      }
      if (type === 'image') {
        str = '単数画像'
      }
      if (type === 'video') {
        str = '単数動画'
      }
      if (type === 'images') {
        str = '複数画像'
      }
      if (type === 'imagesV') {
        str = '複数画像[縦長]'
      }
      if (type === 'titleAndText') {
        str = 'タイトル&テキスト'
      }
      if (type === 'text') {
        str = 'テキスト'
      }
      if (type === 'headlineTitle') {
        str = 'ヘッドラインタイトル'
      }
      if (type === 'multiTitleAndText') {
        str = '2カラム タイトル&テキスト'
      }
      return str
    }
  },
  computed: {
    myList: {
      get () {
        return this.list2
      },
      set (value) {
        this.list2 = value
        value.forEach((v, i) => {
          this.list[i] = v
        })
      }
    }
  },
  created () {
    this.init()
  },
  updated () {
    this.init()
  },
  components: {
    draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Modal/SortElement/index.vue